import { render, staticRenderFns } from "./SourceTypeDependencyWarning.vue?vue&type=template&id=5c8fbedb&scoped=true"
import script from "./SourceTypeDependencyWarning.vue?vue&type=script&lang=js"
export * from "./SourceTypeDependencyWarning.vue?vue&type=script&lang=js"
import style0 from "./SourceTypeDependencyWarning.vue?vue&type=style&index=0&id=5c8fbedb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8fbedb",
  null
  
)

export default component.exports